import type { PropsWithChildren, ReactElement } from 'react';

import { useCan } from '../../hooks/useCan';

type Props = PropsWithChildren<{
    type: string;
    action: string;
    resource?: string;
    loadingFallback?: ReactElement | null;
}>;

const Can = ({ type, action, resource, loadingFallback, children }: Props) => {
    const { can, isLoaded } = useCan({ type, action, resource });

    if (!isLoaded) {
        return loadingFallback ?? null;
    }
    return can ? <>{children}</> : null;
};

export default Can;
